import { css } from '@emotion/react';
import { Children, type ForwardedRef, Fragment, forwardRef, memo, type ReactNode } from 'react';

import { LineSeparator } from '../../../../general/line-separator/LineSeparator';

export type ListRendererProps = {
  /** Separator. */
  withItemSeparator?: boolean;
  /** Items and SubLists. */
  children?: ReactNode;
  /** Class name. */
  className?: string;
};

export const ListRendererBase = forwardRef(
  (
    { children = null, className = null, withItemSeparator = false }: ListRendererProps,
    ref: ForwardedRef<HTMLUListElement>,
  ) => (
    <ul
      ref={ref}
      className={className}
      css={css`
        list-style-type: none;
        display: flex;
        flex-direction: column;
        width: 200px;
        max-height: 300px;
        overflow-y: auto;

        & > *:first-of-type {
          button {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
        }

        & > *:last-of-type {
          button {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
      `}
    >
      {Children.map(children, (child, index) => (
        <Fragment>
          {!!index && index !== Children.count(children) && withItemSeparator && (
            <LineSeparator
              css={css`
                  padding: 0px;
                  margin: 0px;
                `}
            />
          )}
          {child}
        </Fragment>
      ))}
    </ul>
  ),
);

ListRendererBase.displayName = 'ListRenderer';

export const ListRenderer = memo(ListRendererBase);
